import { redirect, replace } from 'react-router'
import { publicAction } from '@/data/loaders';

export function loadRubric({ request, params }) {
  return new Promise(function(resolve, reject) {

    if (params.rubric_id == "new") {
      return resolve({});
    }

    publicAction("getRubric", { id: params.rubric_id }, { educatorOnly: redirect("/courses") }).then(function({ data }) {
      if (data.value) {
        resolve({ data });
      } else {
        reject({text: "Rubric not found or you don't have permission to edit it", path: "/rubrics", status: 404 });
      }
    }).catch(reject);

  })
}

export function loadRubricOverview({ request, params }) {
  return new Promise(function(resolve, reject) {

    const { rubric_id } = params;

    publicAction("getRubricOverview", { id: rubric_id }, { educatorOnly: redirect("/courses") }).then(function({ data }) {
      if (data.value) {
        resolve({ data });
      } else {
        reject({text: "Rubric not found or you don't have permission to view it", path: "/rubrics", status: 404 });
      }
    }).catch(reject);

  })
}

export function rubricSubmit({ request, params }) {
  return new Promise(function(resolve, reject) {
    let searchParams = (new URLSearchParams((new URL(request.url)).search));
    let folder_id = searchParams.get("folder_id");

    request.json().then(function(data) {

      publicAction("createOrUpdateRubric", {
        ...data,
        parent: folder_id || null,
        id: params.rubric_id == "new" ? null : params.rubric_id
      }).then(function({ data }) {
        if (params.rubric_id === "new") {
          resolve(replace("/rubrics/"+data.id));
        } else {
          resolve({success: true, date: Date.now()});
        }
      }).catch(() => {
        resolve({success: false, date: Date.now()});
      });

    })
  })
}